<mat-spinner diameter="70" class="custom-spinner"></mat-spinner>

